import { useEffect } from "react";
import { fullAddress } from "../../lib/site";
import { imgUrl } from "../../lib/api";

function setMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value || "");
}

export const Seo = ({ content, title, description, image }) => {
  useEffect(() => {
    if (!content) {
      return;
    }
    const t = title || content.seo_title;
    const d = description || content.seo_description;
    const img = image ? new URL(imgUrl(image), window.location.origin).href : "";
    document.title = t;
    setMeta("name", "description", d);
    setMeta("property", "og:title", t);
    setMeta("property", "og:description", d);
    setMeta("property", "og:url", window.location.href.split("?")[0]);
    if (img) setMeta("property", "og:image", img);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = window.location.origin + window.location.pathname;
    const ld = {
      "@context": "https://schema.org",
      "@type": "Hotel",
      name: "Vienna Palace Hotel",
      url: window.location.origin,
      telephone: content.phone,
      address: {
        "@type": "PostalAddress",
        streetAddress: content.address_street,
        addressLocality: content.address_city,
        addressRegion: content.address_state,
        postalCode: content.address_cep,
        addressCountry: "BR",
      },
      description: fullAddress(content),
    };
    let s = document.getElementById("ld-hotel");
    if (!s) {
      s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = "ld-hotel";
      document.head.appendChild(s);
    }
    s.textContent = JSON.stringify(ld);
  }, [content, title, description, image]);
  return null;
};
